import React, { useState, useEffect } from 'react';
import { Select } from 'antd';
import { API_ORIGIN } from '../config';

const AutocompleteInput = ({ 
  apiEndpoint, 
  placeholder = "Search...", 
  onSelect,
  disabled = false,
  value = '',
  onChange,
  style = {}
}) => {
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState(value);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleSearch = async (searchTerm) => {
    if (!searchTerm || searchTerm.length < 2) {
      setSearchResults([]);
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${API_ORIGIN}${apiEndpoint}?q=${encodeURIComponent(searchTerm)}`);
      const data = await response.json();
      
      if (response.ok && data.success) {
        const items = data.employees || data.results || data.data || [];
        setSearchResults(items);
      } else {
        setSearchResults([]);
      }
    } catch (error) {
      setSearchResults([]);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (values) => {
    const newValue = values[0] || '';
    setInputValue(newValue);
    setOpen(false); // Close dropdown after selection
    
    if (onChange) {
      onChange(newValue);
    }
    
    if (onSelect && newValue) {
      // Find the full employee object if it exists in results
      const employee = searchResults.find(emp => 
        (emp.email || emp.Email) === newValue
      );
      
      if (employee) {
        onSelect(employee);
      } else {
        // If manually entered, create a minimal object
        onSelect({ email: newValue });
      }
    }
  };

  return (
    <Select
      mode="tags"
      maxCount={1}
      open={open}
      onDropdownVisibleChange={setOpen}
      value={inputValue ? [inputValue] : []}
      placeholder={placeholder}
      style={{ width: '100%', ...style }}
      onSearch={handleSearch}
      onChange={handleChange}
      loading={loading}
      filterOption={false}
      notFoundContent={loading ? 'Searching...' : 'Type at least 2 characters to search'}
      disabled={disabled}
      optionLabelProp="label"
    >
      {searchResults.map(item => {
        const email = item.email || item.Email || '';
        const name = item.name || item.Name || '';
        const surname = item.surname || item.Surname || item.lastName || '';
        const displayName = `${name} ${surname}`.trim() || email;
        
        return (
          <Select.Option key={email} value={email} label={displayName}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <span style={{ fontWeight: 500 }}>{displayName}</span>
              {email && <span style={{ fontSize: '12px', color: '#888' }}>{email}</span>}
            </div>
          </Select.Option>
        );
      })}
    </Select>
  );
};

export default AutocompleteInput;
